import { Box, Paper } from '@mantine/core';

import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { IsiAbstract } from '@/module/AnnualReport/model/AnnualReportTypes';
import { AbstractValidationAction } from '@/module/Author/Abstract/Validation/AbstractValidationAction';
import { AbstractCard } from '@/module/Author/Abstract/components/Card/AbstractCard';
import { PublicationImpactFactor } from '@/module/Journal/components/PublicationImpactFactor';

interface CollapsableAbstractProps {
  title: string;
  abstracts: IsiAbstract[];
}

export function CollapsableIsiAbstract({ title, abstracts }: CollapsableAbstractProps) {
  return (
    <CollapsableGroup
      title={title}
      items={abstracts}
      renderValidation={isi => (
        <AbstractValidationAction
          variant="compact"
          abstractId={isi.abstractItem.id}
        />
      )}
      renderItem={isi => (
        <Paper>
          <AbstractCard
            abstract={isi.abstractItem}
            onClick={() => window.open(`/author/abstract/${isi.abstractItem.id}`)}
          />
          <Box p="sm">
            <PublicationImpactFactor data={isi.metrics} />
          </Box>
        </Paper>
      )}
      getItemKey={isi => isi.abstractItem.id}
    />
  );
}
